import './MailMerge.scss';
import Component from './MailMerge.js';
export default Component;
